import { FontSize } from 'presentation/theme/fontSizes';
import { Color } from 'presentation/theme/colorScheme';

const formLabelTheme = {
  baseStyle: {
    fontSize: FontSize.lg,
    color: Color.OnSurface,
  },
};

export default formLabelTheme;
